/**
 * @desc old name amountConverterPipe
 * @param value
 */
var convertAmount = function (value) {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export { convertAmount };
